"use strict";
// ========================================
// Common Reusable Foundation Schemas
// ========================================
// These schemas provide the building blocks for all domain-specific schemas
// Ensures consistency across the entire application
Object.defineProperty(exports, "__esModule", { value: true });
exports.optional = exports.nullable = exports.basisPointsSchema = exports.signedMoneyAmountSchema = exports.moneyAmountSchema = exports.phoneNumberSchema = exports.uuidSchema = void 0;
const zod_1 = require("zod");
const primitives_1 = require("../../primitives");
// ========================================
// ID SCHEMAS
// ========================================
/**
 * UUID v4 schema
 */
exports.uuidSchema = zod_1.z.string().uuid('Invalid UUID format');
/**
 * Phone number schema (Canadian E.164 format)
 */
exports.phoneNumberSchema = zod_1.z
    .string()
    .regex(/^\+1[2-9]\d{9}$/, 'Phone number must be a valid Canadian number in format +1XXXXXXXXXX')
    .transform(phone => phone.replace(/\s+/g, ''));
// ========================================
// MONEY/CURRENCY SCHEMAS
// ========================================
/**
 * Money amount (in cents to avoid floating point issues)
 */
exports.moneyAmountSchema = primitives_1.moneyAmountPrimitiveSchema;
/**
 * Signed money amount (in cents)
 * Useful for adjustments/transactions that can be positive or negative.
 */
exports.signedMoneyAmountSchema = primitives_1.signedMoneyAmountPrimitiveSchema;
/**
 * Basis points (0-10000) for percentage representation as integers
 * 1 basis point = 0.01%, 100 basis points = 1%, 10000 basis points = 100%
 * Use BasisPointsService for conversions and formatting
 */
exports.basisPointsSchema = primitives_1.basisPointsPrimitiveSchema;
// ========================================
// HELPER FUNCTIONS
// ========================================
/**
 * Create a nullable version of any schema
 */
const nullable = (schema) => schema.nullable();
exports.nullable = nullable;
/**
 * Create an optional version of any schema
 */
const optional = (schema) => schema.optional();
exports.optional = optional;
